import { render } from "./AddEventModal.vue?vue&type=template&id=c2ce4a5c&scoped=true"
import script from "./AddEventModal.vue?vue&type=script&lang=js"
export * from "./AddEventModal.vue?vue&type=script&lang=js"

import "./AddEventModal.vue?vue&type=style&index=0&id=c2ce4a5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2ce4a5c"]])

export default __exports__